// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./index.css";
import App from "./App";
import Homepage from "./homepage";
import Layout from "./Layout";
import reportWebVitals from "./reportWebVitals";
import Profile from "./Profile";
import Map from "./Map";

function RequireAuth({ children }) {
  const authed = Boolean(localStorage.getItem("token"));
  return authed ? children : <Navigate to="/" replace />;
}

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />

        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route path="/Homepage" element={<Homepage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/map/:id" element={<Map />} />
          <Route path="/map/:id/edit" element={<Map />} />
        </Route>

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
